module.exports = __webpack_public_path__ + "img/pic26.9cb469b9.png";